import { useState } from 'react'
import { setPersistedItem } from 'utils/persistedStorage.ts'
import { InstalmentInfoModalProps } from './types'
import { Button, Modal } from '@boltenergy-be/design-system'
import { useTranslation } from 'react-i18next'
import styles from './InstalmentInfoModal.module.scss'
import { NEVER_SHOW_INSTALMENT_INFO_MODAL } from '../../constants'
import parse from 'html-react-parser'
import { useStoreSelector } from 'hooks/store.ts'
import { selectCurrentProduct } from 'store/contact/slice.ts'
import { PRODUCTS } from '@boltenergy-be/shared'

const InstalmentInfoModal = ({ isOpen, setClose }: InstalmentInfoModalProps) => {
  // Redux
  const elProduct = useStoreSelector(selectCurrentProduct)

  // Local state
  const [checkboxChecked, setCheckboxChecked] = useState<boolean>(false)

  // i18n
  const { t } = useTranslation('billing')

  /**
   * Closes the modal and persists to never show it again
   */
  const closeModal = () => {
    if (checkboxChecked) {
      setPersistedItem(NEVER_SHOW_INSTALMENT_INFO_MODAL, 'true', 365)
    }

    setClose()
  }

  return (
    <Modal
      onRequestClose={() => closeModal()}
      {...{ isOpen }}
      className={styles.modal}
      title={t(($) => $.billingCycles.current.instalmentInfoModal.title)}
    >
      <p>{parse(t(($) => $.billingCycles.current.instalmentInfoModal[elProduct === PRODUCTS.fix ? 'descriptionFix' : 'description']))}</p>

      <footer className={styles.footer}>
        <form>
          <label className={styles.checkbox}>
            <input type="checkbox" checked={checkboxChecked} onChange={() => setCheckboxChecked(!checkboxChecked)} />
            <span>{t(($) => $.billingCycles.current.instalmentInfoModal.checkbox)}</span>
          </label>
        </form>

        <Button onClick={closeModal}>{t(($) => $.billingCycles.current.instalmentInfoModal.close)}</Button>
      </footer>
    </Modal>
  )
}

export default InstalmentInfoModal
